<template>
  <div class="bar">
    <div class="bar-header">
      <div class="logo"></div>
      <div class="contact" v-if="setting.supportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{setting.supportPhone}}</div>
      </div>
      <div class="timer">
        <div class="timer-label">Осталось</div>

        <div class="timer-time">
          <Timer starttime="Sep 4, 2018 18:00:00" :endtime="this.user.sessionEndAt" trans='{
           "day":"Дней",
           "hours":"Часов",
           "minutes":"Минут",
           "seconds":"Секунд",
           "expired":"Event has been expired.",
           "running":"До конца сессии",
           "upcoming":"С начала сессии",
           "status": {
              "expired":"Истек",
              "running":"Запущен",
              "upcoming":"Future"
             }}'></Timer>
        </div>
      </div>
      <div class="button-back" @click="goBack">
        <span class="btn-icon fa fa-long-arrow-left"></span>
      </div>
    </div>
    <div class="bar-menu">
      <div class="bar-menu__item" v-for="(group, groupIndex) in bar" :key="'bar-group-'+groupIndex" @click="setCurrentGroupId(groupIndex)" :class="{active: isActiveGroup(groupIndex)}">
        {{group.name}}
      </div>
    </div>
    <div class="bar-body">
      <div class="bar-item mobile" v-for="(item, mobileIndex) in currentGroup" :key="'bar-item-mobile-' + currentGroupId + '-' + mobileIndex" :style="{order: item.number}">
        <div class="image">
          <img :src="item.imageUrl" :alt="item.name" v-if="item.imageUrl">
          <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 457.582 457.582" style="enable-background:new 0 0 457.582 457.582;" xml:space="preserve" width="512px" height="512px">
            <path d="M11.796,306.42h237.037c1.668,0,3.26-0.711,4.381-1.947s1.67-2.887,1.51-4.548c-4.563-47.249-58.519-84.545-124.41-84.545   S10.467,252.677,5.905,299.926c-0.161,1.662,0.385,3.315,1.507,4.552C8.533,305.715,10.126,306.42,11.796,306.42z" fill="#0d76ff"/>
            <path d="M248.832,364.24H11.796c-1.67,0-3.262,0.706-4.384,1.942c-1.122,1.237-1.667,2.891-1.507,4.553   c1.243,12.86,6.148,24.982,13.955,35.816c5.03,6.979,13.114,11.109,21.718,11.109H219.05c8.59,0,16.695-4.14,21.717-11.109   c7.807-10.834,12.712-22.956,13.955-35.816c0.16-1.661-0.388-3.312-1.51-4.548S250.501,364.24,248.832,364.24z" fill="#0d76ff"/>'
            <path d="M245.744,320.604H14.884C6.664,320.604,0,327.267,0,335.487c0,8.22,6.664,14.883,14.884,14.883h230.86   c8.22,0,14.883-6.664,14.883-14.883C260.627,327.267,253.963,320.604,245.744,320.604z" fill="#0d76ff"/>
            <path d="M442.698,172.329c-2.108,0-3.332-2.311-2.22-4.102c1.378-2.222,2.188-4.833,2.219-7.634   c0.094-8.281-7.035-15.055-15.317-15.055h-63.196l4.921-68.878l52.885,22.49c7.782,3.31,16.813-0.519,19.787-8.542   c2.786-7.514-1.15-15.879-8.524-19.016L361.57,41.109c-4.425-1.881-9.486-1.51-13.587,0.998c-4.103,2.508-6.74,6.842-7.083,11.638   l-6.558,91.794h-63.777c-8.281,0-15.41,6.774-15.317,15.055c0.032,2.801,0.841,5.412,2.219,7.634   c1.111,1.791-0.113,4.102-2.22,4.102c-8.22,0-14.883,6.664-14.883,14.884c0,7.101,4.813,14.515,11.629,14.515   c56.444,0,138.568,0,193.96,0c6.816,0,11.629-7.415,11.629-14.515C457.582,178.992,450.918,172.329,442.698,172.329z" fill="#0d76ff"/>
            <path d="M284.99,405.52c0.817,6.924,6.686,12.141,13.657,12.141h100.65c6.972,0,12.841-5.217,13.658-12.141l22.375-189.609H262.615   L284.99,405.52z" fill="#0d76ff"/>
          </svg>
        </div>
        <div class="info">
          <div class="name">{{item.name}}</div>
          <!-- <div class="description">Placeholder for item description. Useful for combo's</div> -->
          <div class="price">Цена: {{item.price}} {{setting.currency}}</div>
          <div class="counter">
            <span class="counter-minus fa fa-minus" @click="dec(item, mobileIndex)"></span>
            <span class="counter-quantity">{{item.count ? item.count : 0}}</span>
            <span class="counter-plus fa fa-plus" @click="inc(item, mobileIndex)"></span>
          </div>
        </div>
      </div>

      <div class="bar-item desktop" v-for="(item, index) in currentGroup" :key="'bar-item-desktop-' + currentGroupId + '-' + index" :style="{order: item.number}" :class="{added : itemInCart(item)}">
        <div class="blur"></div>
        <div class="image">

          <img :src="item.imageUrl" :alt="item.name" v-if="item.imageUrl">
          <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 457.582 457.582" style="enable-background:new 0 0 457.582 457.582;" xml:space="preserve" width="512px" height="512px">
            <path d="M11.796,306.42h237.037c1.668,0,3.26-0.711,4.381-1.947s1.67-2.887,1.51-4.548c-4.563-47.249-58.519-84.545-124.41-84.545   S10.467,252.677,5.905,299.926c-0.161,1.662,0.385,3.315,1.507,4.552C8.533,305.715,10.126,306.42,11.796,306.42z" fill="#0d76ff"/>
            <path d="M248.832,364.24H11.796c-1.67,0-3.262,0.706-4.384,1.942c-1.122,1.237-1.667,2.891-1.507,4.553   c1.243,12.86,6.148,24.982,13.955,35.816c5.03,6.979,13.114,11.109,21.718,11.109H219.05c8.59,0,16.695-4.14,21.717-11.109   c7.807-10.834,12.712-22.956,13.955-35.816c0.16-1.661-0.388-3.312-1.51-4.548S250.501,364.24,248.832,364.24z" fill="#0d76ff"/>'
            <path d="M245.744,320.604H14.884C6.664,320.604,0,327.267,0,335.487c0,8.22,6.664,14.883,14.884,14.883h230.86   c8.22,0,14.883-6.664,14.883-14.883C260.627,327.267,253.963,320.604,245.744,320.604z" fill="#0d76ff"/>
            <path d="M442.698,172.329c-2.108,0-3.332-2.311-2.22-4.102c1.378-2.222,2.188-4.833,2.219-7.634   c0.094-8.281-7.035-15.055-15.317-15.055h-63.196l4.921-68.878l52.885,22.49c7.782,3.31,16.813-0.519,19.787-8.542   c2.786-7.514-1.15-15.879-8.524-19.016L361.57,41.109c-4.425-1.881-9.486-1.51-13.587,0.998c-4.103,2.508-6.74,6.842-7.083,11.638   l-6.558,91.794h-63.777c-8.281,0-15.41,6.774-15.317,15.055c0.032,2.801,0.841,5.412,2.219,7.634   c1.111,1.791-0.113,4.102-2.22,4.102c-8.22,0-14.883,6.664-14.883,14.884c0,7.101,4.813,14.515,11.629,14.515   c56.444,0,138.568,0,193.96,0c6.816,0,11.629-7.415,11.629-14.515C457.582,178.992,450.918,172.329,442.698,172.329z" fill="#0d76ff"/>
            <path d="M284.99,405.52c0.817,6.924,6.686,12.141,13.657,12.141h100.65c6.972,0,12.841-5.217,13.658-12.141l22.375-189.609H262.615   L284.99,405.52z" fill="#0d76ff"/>
          </svg>
        </div>
        <div class="info">
          <div class="name">{{item.name}}</div>
          <!-- <div class="description">Placeholder for item description. Useful for combo's</div> -->
          <div class="price">Цена: {{item.price}} {{setting.currency}}</div>
          <div class="counter">
            <span class="counter-minus fa fa-minus" @click="dec(item, index)"></span>
            <span class="counter-quantity">{{item.count ? item.count : 0}}</span>
            <span class="counter-plus fa fa-plus" @click="inc(item, index)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="bar-footer">
      <div class="basket-step-forward">
        <div class="basket-btn" @click="goNext">
          <span class="btn-icon"></span>
          <span class="btn-label">Купить {{cart.ticketSum + cart.barSum}} {{setting.currency}}</span>
        </div>
      </div>
    </div>

    <WarningModal v-bind:icon="warningImage" v-bind:title="warningTitle" v-bind:text="warningText"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { types } from "@/types";
import Timer from "@/components/Timer";
import { find, indexOf } from "lodash";
import WarningModal from '@/components/WarningModal'

export default {
  name: "BarGroup",

  data() {
    return {
      currentGroupId: 0,
      warningImage: '',
      warningTitle: '',
      warningText: ''
    };
  },

  components: {
    Timer,
    WarningModal
  },

  mounted() {
    if (!this.user.ticketOrderId) {
      this.$store.dispatch("reserveTicket", {
          theatreId: this.$route.params.theatreId,
          sessionId: this.$route.params.session
        })
    }
    if (this.setting.notification2Show && this.session.Format && (this.session.Format.Name == '3D' || !this.setting.notification2Only3d)) {
      this.warningImage = this.setting.notification2Image;
      this.warningTitle = this.setting.notification2Title;
      this.warningText = this.setting.notification2Descr;
      this.$modal.show('warning-modal');
    }
    console.log(this.user.ticketOrderId, "this.user.ticketOrderId-2")
  },

  computed: {
    ...mapState(["bar", "cart", "session", "user", "setting"]),
    currentGroup() {
      if (this.bar.length) {
        return this.bar[`${this.currentGroupId}`]["items"];
      }
    },
  },

  methods: {
    setCurrentGroupId(index) {
      this.currentGroupId = index;
    },
    isActiveGroup(index) {
      return index == this.currentGroupId;
    },
    goNext() {
      if (this.cart.bar.length > 0) {
        this.$store.dispatch("barReserve", {
          theatreId: this.$route.params.theatreId
        });
      }

      this.$store.dispatch("logRoute", {
        changes: "Переход на страницу Подтверждения заказа",
        status: "up"
      });
      this.$router.push(
        `/${this.$route.params.theatreId}/${this.$route.params.session}/buy-bar`
      );
    },

    goBack() {
      this.$router.push(
          `/${this.$route.params.theatreId}/${this.$route.params.session}/hall`
      );
    },

    getItemImage(item) {
      console.log(item);
      console.log(item.imageUrl ? item.imageUrl : this.getNotFoundImg());

      return item.imageUrl ? item.imageUrl : this.getNotFoundImg();
    },

    itemInCart(item) {
      return item.count > 0;
    },

    inc(item, index) {
      let itemInCart = find(this.cart.bar, ["productId", item.productId]);
      // console.log(itemIncart);
      this.$store.dispatch("logAddBarItem", {
        item: item,
      });

      if (typeof itemInCart !== "object") {
        this.$store.commit(types.ADD_BAR_TO_CART, {
          item: item,
          index: index
        });
      } else {
        let cartIndex = indexOf(this.cart.bar, item);
        this.$store.commit(types.CHANGE_BAR_IN_CART, {
          index: cartIndex,
          count: 1
        });
      }
    },

    dec(item) {
      let itemInCart = find(this.cart.bar, ["productId", item.productId]);

      this.$store.dispatch("logRemoveBarItem", {
        item: item,
      });

      if (typeof itemInCart === "object") {
        if (itemInCart.count < 1) {
          return;
        }

        let index = indexOf(this.cart.bar, item);
        if (itemInCart.count > 1) {
          this.$store.commit(types.CHANGE_BAR_IN_CART, {
            index,
            count: -1
          });
        } else {
          this.$store.commit(types.REMOVE_BAR_FROM_CART, index);
        }
      }
    }
  }
};
</script>

<style lang="scss">
%circle-btn {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  position: absolute;
  top: 10px;
  padding: 0;
  width: 42px;
  height: 42px;
  border: 2px solid #fff;
  border-radius: 100%;
  opacity: 0.3;
  cursor: pointer;
  justify-content: center;
  transition: 0.15s ease-in-out;
  &:hover {
    opacity: 1;
  }
}

.bar {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  &-menu {
    display: flex;
    flex-wrap: nowrap;
    height: 65px;
    align-items: center;
    border-bottom: 1px solid #fff3;
    overflow-x: auto;
    overflow-y: hidden;
    position: fixed;
    width: 100%;
    top: 65px;
    left: 0;
    z-index: 10;
    background: #24262ce6;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
      background-color: transparent;
      border-radius: 1px;
      height: 6px;
    }
    &::-webkit-scrollbar {
      height: 6px;
      background-color: #f5f5f5;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #0d76ff;
      border-radius: 10px;
    }
    &__item {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 15px;
      cursor: pointer;
      color: #ffffff;
      font-weight: 700;
      user-select: none;
      transition: 0.15s ease-in-out;
      box-sizing: border-box;
      border-top: 1px solid transparent;
      text-align: center;
      white-space: nowrap;
      &:hover {
        border-top: 1px solid #0d76ff;
      }
      &.active {
        border-top: 2px solid #0d76ff;
      }
    }
  }
  &-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    color: #fff;
    padding: 0 80px;
    border-bottom: 1px solid #fff3;
    box-sizing: border-box;
    overflow: hidden;
    box-sizing: border-box;
    flex: 1 0 auto;
    position: fixed;
    width: 100%;
    height: 65px;
    top: 0;
    left: 0;
    z-index: 10;
    background: #24262ce6;
    .logo {
      display: none;
      width: 166px;
      height: 25px;
    }
    .timer {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      justify-content: space-between;
      width: 210px;
      white-space: normal;
      &-label {
        text-transform: uppercase;
        padding: 0 7px 0 0;
        font-size: 9px;
        line-height: 11px;
        letter-spacing: 0.06em;
        margin-bottom: 2px;
        padding: 0;
        letter-spacing: 1px;
        color: #fffc;
      }
      &-time {
        font-size: 17px;
        line-height: 21px;
        color: #fff;
        letter-spacing: 0.1em;
      }
    }
    .contact {
      display: none;
      position: absolute;
      right: 90px;
      top: 15px;
      &-label {
        text-transform: uppercase;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 1px;
        color: #fff;
        color: #fffc;
        margin-bottom: 2px;
      }
      &-number {
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
        letter-spacing: 0.5px;
        color: #fff;
      }
    }
    .button-back {
      @extend %circle-btn;
      left: 15px;
      cursor: pointer;
      .label {
        margin-left: 15px;
      }
    }
    .button-close {
      @extend %circle-btn;
      right: 15px;
      .btn-icon {
        // width: 26px;
        // height: 26px;
        background-position: 50% 50%;
      }
    }
  }
  &-body {
    display: flex;
    flex-wrap: wrap;
    /*margin-bottom: 110px;*/
    margin-top: 145px;
    padding-bottom: 110px;
    z-index: 5;
    flex-grow: 1;
    flex-shrink: 0;
    }
  &-item {
    display: flex;
    position: relative;
    background-color: #0000;
    align-items: center;
    transition: 75ms;
    align-items: flex-start;
    padding: 30px;
    box-sizing: border-box;
    cursor: pointer;
    &.desktop {
      display: none;
      .image img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        min-width: 100px;
        margin: 0;
      }
      .image svg {
        max-width: 100%;
        max-height: 100%;
      }
      .info {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 20;
        height: 25%;
        padding: 5px 20px;
        background-color: #0d76ff33;
        color: #fff;
        transition: 0.3s ease-in-out;
        font-weight: 700;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        border-radius: 50px;
      }
    }
    .image {
      z-index: 10;
      width: 75px;
      margin-right: 10px;
      position: relative;
      width: 100%;
      height: 100%;
      img {
        height: auto;
        width: auto;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      svg {
        height: auto;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: 100%;
      }
    }
    .info {
      .name {
        font-size: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-shrink: 0;
        overflow: hidden;
        line-height: 22px;
        text-align: center;
        transition: .25s ease-in-out;
      }
      .description {
        height: 0;
        opacity: 0;
        transition: 0.3s ease-in-out;
        &:empty {
          display: none;
        }
      }
      .price {
        font-size: 18px;
        text-align: center;
        transition: .15s ease-in-out;
      }
      .counter {
        opacity: 0;
        transition: opacity .2s ease-in-out, height .2s ease-in-out, margin .4s ease-in-out;
        text-align: center;
        width: 100%;
        display: inline-flex;
        align-items: center;
        margin: 0 auto;
        justify-content: center;
        height: 0;
      }
      .counter-quantity {
        font-size: 22px;
        user-select: none;
      }
      .counter-plus,
      .counter-minus {
        cursor: pointer;
        margin: auto 5px;
        background-color: #0d76ff;
        font-size: 14px;
        color: #ffffff;
        // font-weight: 700;
        border-radius: 8px;
        height: 45px;
        width: 55px;
        margin: 0 1em;
        text-align: center;
        min-width: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: 0.15s ease-in-out;
        &:hover {
          background-color: #005dd5;
        }
      }
    }
    &:hover .info,
    &.added .info {
      height: 100%;
      background: #0006;
      padding: 10px 15px;
      border-radius: 15px;
      .price {
        font-size: 20px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      .name {
        white-space: pre-wrap;
        font-size: 22px;
      }
      .description {
        opacity: 1;
        // height: 30%;
      }
      .counter {
        opacity: 1;
        height: 35px;
        margin: 0 auto 20px;
        transition: opacity .4s ease-in-out, height .2s ease-in-out, margin .4s ease-in-out;
        // transition: none;
      }
    }
    &.mobile {
      background-color: #fff;
      width: 100%;
      padding: 10px 15px;
      color: #000;
      border-bottom: 1px solid #000;
      height: 190px;
      &:hover {
        .info {
          background: none;
          height: 100%;
          padding: 0;
          border-radius: 0;
          .name {
            white-space: nowrap;
            font-size: 16px;
          }
          .price {
            font-size: 18px;
          }
          .counter {
            margin: 0 auto;
          }
        }
      }
      .info {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: 100%;
        justify-content: space-between;
        .description,
        .counter {
          opacity: 1;
          height: auto;
        }
        .description {
          height: auto;
        }
        .size {
          color: #ffffff;
        }
      }
    }
  }
  &-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    background-color: #24262ce6;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    padding: 5px;
    border-top: 1px solid #cdcfd024;
    z-index: 30;
    font-size: 18px;
  }
}

@media only screen and (min-width: 768px) {
  .bar-header .contact {
    display: block;
  }
  .bar-item {
    &.mobile {
      display: none;
    }
    &.desktop {
      display: flex;
      height: calc(100vw /4 - 20px);
      margin: 10px;
      width: calc(100% /4 - 20px);
    }
    .info {
      .counter-plus,
      .counter-minus {
        margin: auto 5px;
        color: #fff;
        background-color: #0d76ff;
        height: 35px;
        width: 38px;
        margin: 0 1em;
        min-width: 30px;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .bar-footer {
    padding: 20px 4% 20px;
  }
  .basket-step-forward {
    flex: 0 0 250px;
  }
  .basket-btn {
    padding: 0 32px;
  }
}

@media only screen and (min-width: 1024px) {
  .bar-item.desktop {
    width: calc(100% / 4 - 30px);
    height: calc(100vw / 4 - 30px);
    margin: 15px;
  }
}

 @media only screen and (max-width: 480px) {
    .bar-item .info .name, .bar-item.mobile:hover .info .name {
        white-space: normal;
    }
}

@media only screen and (max-width: 375px) {
    .bar-item .image img {
        width: 100%;
    }
}

@media only screen and (max-height: 480px) {
  .bar-header {
    height: 65px !important;
    padding: 0 15px !important;
  }

  .bar-header .button-back, .bar-header .button-close {
    top: 10px;
    left: 15px;
  }

  .bar-header .contact-label {
    text-align: end;
  }

  .bar-header .contact {
    top: 15px;
  }

  .bar-menu__item {
    padding: 0 15px;
  }
  
  .bar-menu {
    height: 30px;
    top: 65px;
    font-size: 14px;
  }
  
  .bar-footer {
    font-size: 14px;
    padding: 10px;
  }

  .basket-btn {
    height: 35px;
  }

  .button-close {
    top: 10px;
  }
}
</style>
